// TODO move to components/text/

import { Text } from "@chakra-ui/react";

// Hm... these score over variants in that the compiler checks them
// They are text-only, but that's OK here

export const LabelText = ({ children, mt = 1, ...props }) => (
  <Text as="label" variant="rightSidebarLabel" mt={mt} {...props}>
    {children}
  </Text>
);

export const ValueText = ({ children, ...props }) => (
  <Text variant="rightSidebarValue" {...props}>
    {children}
  </Text>
);

export const SmallText = ({ children, ...props }) => (
  <Text {...props}>
    <small>{children}</small>
  </Text>
);
